import { type TrackingSources } from '@lib/tracking/TrackingSources'
import { getBackgroundGradient } from '@lib/utilities/getBackgroundGradient'
import { ArticleCardCarousel } from '../ArticleCardCarousel'

type GraphiteRelatedArticle = {
  title: string
  url: string
}

interface RelatedArticleLinksProps {
  relatedArticles: GraphiteRelatedArticle[]
  trackingSource: TrackingSources
}

/**
 * Render a list of links to articles from the Graphite Interlinking API as article link cards.
 *
 * @param relatedArticles List of articles to display
 */
export default function RelatedArticleLinks({
  relatedArticles,
  trackingSource,
}: RelatedArticleLinksProps) {
  const relatedArticleCards = (relatedArticles ?? []).map(
    (relatedArticle, index) => {
      const href = relatedArticle.url

      return {
        backgroundGradient: getBackgroundGradient(index + 8), // Shift the gradient modulo
        description: relatedArticle.title,
        href,
        trackingSource,
      }
    },
  )

  if (relatedArticleCards.length < 1) {
    return null
  }

  return (
    <section id='related-articles'>
      <div className='mx-auto grid grid-cols-1 gap-4 py-4'>
        <ArticleCardCarousel
          cards={relatedArticleCards}
          subheading='Popular Guides'
        />
      </div>
    </section>
  )
}
